import React from 'react';
import PropTypes from 'prop-types';
import { withStyles} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Header from './../Header';
import Footer from './../Footer';
import { login, addRegistration, loginWithEds } from './../../actions/actions';
import { roles } from './../../helpers/trans'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Chip from '@material-ui/core/Chip';
import { Redirect } from  "react-router-dom";
import { styles } from './../../helpers/classes';
import { check } from './../../helpers/browser';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import moment from 'moment';
import 'moment/locale/ru';
import { DatePicker } from 'material-ui-pickers';

const attributes = {
    company_name: "Наименование юридического лица",
    contact_name: "Имя Фамилия Отчество",
    contact_email: "Email контактного лица",
    company_country: "Страна",
    company_state: "Область",
    company_region: "Район",
    company_city: "Населенный пункт",
    company_street:"Улица",
    company_phone: "Номер телефона",
    tax_company_name: "Наименование Инспекции по налогам и сборам",
    okpo: "ОКПО",
    unp: "УНП",
    certificate_number: "Номер аттестата соответствия и его категория",
    certificate_date:"Дата выдачи аттестата соответствия"
}

function TabContainer(props) {
    return (
        <Typography component="div">
            {props.children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired
};

class LoginPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            redirect: false,
            user: {},
            reg: false,
            value: 0,
            status: 'new',
            fetching: false,
            response_status: '',
            message: '',
            eds_submitted: false,
            eds_success: false,
            eds_message: '',
            reg_form_data: {
                company_name: '',
                contact_name: '',
                contact_email: '',
                company_country: '',
                company_state: '',
                company_region: '',
                company_city: '',
                company_street: '',
                company_phone: '',
                tax_company_name: '',
                okpo: '',
                unp: '',
                certificate_number: '',
                certificate_serial_number: '',
                certificate_date: null,
            },
            login_form_data: {
                username: '',
                password: '',
            }
        };
    }

    handleClose = () => {
        this.setState({ open: false });
    };

    parseApplet = () => {
          var my_app = document.getElementById('appletNumberBH1');
         // var my_app = document.applets[0];

        try {
            var ser_num = my_app.get_serNum();
            return JSON.parse(ser_num);
        } catch (e) {
            let message = e.message;
            if (e.message.indexOf('get_serNum') > -1 || e.message == 'my_app.get_serNum is not a function' || e.message == "Object doesn't support property or method 'get_serNum'") {
                message = 'В браузере не настроена работа с апплетами';
                let bData = check();
                let theMessage = (
                    <Typography body2>
                        <Typography paragraph>
                            В браузере не настроена работа с апплетами, возможные причины :
                        </Typography>
                        <Typography paragraph style={{ fontWeight: 'bold'}}>
                            1. Вход через некорректный браузер
                        </Typography>
                        {!(bData.browserName =='Microsoft Internet Explorer' && (bData.majorVersion == 9 || bData.majorVersion == 10 || bData.majorVersion == 11)) &&
                        (<Typography paragraph>
                            Ваш браузер  {bData.browserName} {bData.majorVersion} не поддерживается. Для операций с ЭЦП пожалуйста используйте браузеры Internet Explorer 9, 10, 11.
                        </Typography>)}
                        <Typography paragraph>
                            Также убедитесь в корректных настройках, необходимых для работы с ЭЦП. <a href="https://dkns.by/departament/podacha-uvedomlenij">Перейти к инструкции по настройкам</a>
                        </Typography>
                        <Typography paragraph style={{ fontWeight: 'bold'}}>
                            2. Отсутствует Java
                         </Typography>
                        <Typography paragraph>
                            Проверьте наличие Java на вашем компьютере. <a href="https://dkns.by/departament/podacha-uvedomlenij">Перейти к инструкции по настройкам</a>
                        </Typography>
                    </Typography>
                )
                  this.setState({open:true, message: theMessage});
            }
            return {code: 1000, message: message, subject:'',ynp:''};
            // return Math.round(Math.random()) == 1 ? {
            //     code: 0,
            //     message: Math.floor(Math.random() * 16777215000900099090).toString(16),
            //     subject: `STREET=ул.Берестянская, д.6, CN=Специализированная инспекция Департамента контроля и надзора за строительством, SN=Шваюнов, C=BY, O=Специализированная инспекция Департамента контроля и надзора за строительством, Имя, Отчество=Александр Олегович, L=г.Минск`,
            //     ynp: Math.floor(Math.random() * 1000000000)
            // } :
            // {code: 1, message: "Ошибка контекста криптопровайдера", subject: '', ynp: ''};
        }
    }

    handleEds = () => {
        let data = this.parseApplet();
        if (data.code == 0) {
            let str = data.subject;
            let currentData = this.state.reg_form_data;
            /// Parsing an object ///
            /// Finish Parsing an object ///
            let company_name = str.split('CN=').pop().split(',')[0];
            let street_line = str.split('STREET=').pop().split(', CN=')[0];
            let block = street_line.split(', д.').pop().split(',')[0];
            let building = str.indexOf(', к.') > -1 ? street_line.split(', к.').pop().split(',')[0] : '';
            let surname = str.split('SN=').pop().split(',')[0];
            let names = str.split('Имя, Отчество=').pop().split(',')[0];
            let loc = str.split('L=').pop().split(',')[0];
            // todo cut or not city kind
            //let city = loc.split('.').pop();
            let street = str.split('STREET=').pop().split(',')[0];
            let email = str.indexOf('E=') > -1 ? str.split('E=').pop().split(',')[0] : '';
            let country = str.indexOf(', C=') > -1 && str.split(', C=').pop().split(',')[0] == 'BY' ? 'Беларусь' : '';
            let newData = {
                company_email: email,
                certificate_serial_number: data.message,
                unp: data.ynp,
                company_name: company_name,
                contact_name: `${surname} ${names}`.trim(),
                contact_email: email,
                company_country: country,
                company_street: street_line,
                company_city: loc,
                company_block: block,
                company_building: building
            };
            this.setState({reg: true, eds_message: '', reg_form_data: {...currentData, ...newData}});
        }
        if (data.code >= 0) {
            this.setState({eds_message: data.message});
        }
    }

    handleChange = (event, value) => {
        this.setState({value});
    };

    updateDateInput = name => date => {
        console.log(date);
        console.log(name);
        let value = date.toISOString().split('T')[0];
        let data = {[name]: value } ;
        let currentData = this.state.reg_form_data;
        this.setState({reg_form_data:{ ...currentData, ...data}});
    }

    handleInputChange = (event, value) => {
        this.console.log(event.target)
    };

    render() {
        let bData = check();
        let not_show_content = (bData.browserName =='Microsoft Internet Explorer' && (bData.majorVersion < 9));
        const {classes, user} = this.props;
        const {value, reg, status, message, redirect} = this.state;
        if ('role' in user && Array.isArray(user.role)) {
            console.log(user.role);
            if (user.role.indexOf(roles.ROLE_SUPER_ADMIN) >= 0) {
                return (<Redirect to="/admin/"/>);
            }
            if (user.role.indexOf(roles.ROLE_SUPERVISOR) >= 0) {
                return (<Redirect to="/supervision/" />);
            }
            if (user.role.indexOf(roles.ROLE_INSPECTOR_MANAGER) >= 0 ||
                user.role.indexOf(roles.ROLE_INSPECTOR_APPEALS) >= 0 ||
                user.role.indexOf(roles.ROLE_INSPECTOR_MAIN) >= 0 ||
                user.role.indexOf(roles.ROLE_INSPECTOR_RECEIVE) >= 0 ||
                user.role.indexOf(roles.ROLE_INSPECTOR_REPLIES) >= 0) {
                return (<Redirect to="/inspection/"/>);
            }
            console.log(user.role.indexOf(roles.ROLE_BUILD_USER));
            if (user.role.indexOf(roles.ROLE_BUILD_ORG) >= 0 ||
                user.role.indexOf(roles.ROLE_BUILD_USER) >= 0) {
                return (<Redirect to="/org-cabinet/"/>); 
            }
        }
                return (
                    <Typography body2 >
                        <Header />
                        {not_show_content && (<Typography className={classes.textStatic} style={{marginLeft: '12%', height: '70%'}}>Версия вашего браузера устарела. Обновите браузер до актуальной версии</Typography>)}
                        {(!not_show_content) && (<Typography className={classes.root} style={{display:'block', paddingBottom:'10em'}}>
                                    <Typography style={{marginLeft: '12%', marginRight: '12%'}}>
                                        <Typography variant="h2" className={classes.headerStatic} variant="headline"> Авторизация в системе</Typography>
                                        <object type="application/x-java-applet" height="60" id="appletNumberBH1">
                                            <param name="code" value="appletNumberBH1"/>
                                            <param name="archive" value="appletNumberBH1.jar,jna-3.0.9.jar"/>
                                            <param name="codebase" value="/applet/"/>
                                            <param name="huhuid"/>
                                            {/* <Chip
                                                style={{backgroundColor: '#76b5b8', marginLeft:'30%', padding:'1em'}}
                                                label="Ошибка загрузки апплета. Java plug-in не найден"/>
                                            */}</object>
                                        <AppBar position="static" classes={{root: classes.appBar}}>
                                            <Tabs
                                                value={this.state.value}
                                                onChange={this.handleChange}
                                                indicatorColor="primary"
                                                textColor="primary"
                                                fullWidth
                                                classes={{indicator: classes.indicator}}
                                            >
                                                <Tab className={classes.h5} classes={{root: classes.tabRoot, label: classes.tabLabel}} label="Войти в личный кабинет" />
                                                <Tab className={classes.h5} classes={{root: classes.tabRoot, label: classes.tabLabel}} label="Зарегистрироваться" />
                                            </Tabs>
                                        </AppBar>
                        {value === 0 && <TabContainer>
                            <div style={{marginLeft:'20%', marginRight:'20%'}} >
                            <form className={classes.container} onSubmit={this.handleLogin}>
                                <div className={classes.wrapperButton}>
                                    <Button onClick={this.handleEdsLogin} variant="outlined" color="#76b5b8" size="large"
                                            className={ classes.buttonLeft }>
                                        Войти по ЭЦП
                                    </Button>
                                </div>
                                <TextField
                                    required
                                    name="username" id="username"
                                    onChange={e => this.updateLoginInput(e.target)}
                                    label="Логин"
                                    fullWidth
                                    margin="normal"
                                    className={classes.textField}
                                    classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor,}}
                                    InputProps={{ className: classes.input}}
                                    InputLabelProps={{shrink: true,className: classes.label }}
                                />
                                <TextField
                                    required type="password"
                                    name="password"
                                    label="Пароль"
                                    onChange={e => this.updateLoginInput(e.target)}
                                    id="password"
                                    margin="normal"
                                    fullWidth
                                    className={classes.textField}
                                    classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor,}}
                                    InputProps={{  className: classes.input }}
                                    InputLabelProps={{  shrink: true, className: classes.label}}
                                />
                                <div className={classes.wrapperButton}>
                                    <Button type="submit" variant="outlined" color="#76b5b8" size="large"
                                            className={ classes.button }>
                                        Войти
                                    </Button>
                                </div>
                            </form>
                            {('message' in this.props.user) && (<Typography paragraph style={{color:"red", padding: "2em"}}>{this.props.user.message}</Typography>)}
                        </div>
                        </TabContainer>}
                        {value === 1 && 
                        <TabContainer indicatorColor={classes.primary}>
                            {/*<p>Отправьте заявку на регистрацию. Мы свяжемся с вами для уточнения деталей</p>*/}
                            {this.props.status !== 'completed' && (
                                    <form className={classes.container} onSubmit={this.handleRegistration}>
                                    <Typography variant="div" className={classes.wrapperButton}>
                                <Button  onClick={this.handleEds}
                                         variant="outlined"
                                         color="#76b5b8"
                                         size="large"
                                         className={ classes.buttonS }>
                                    Получить данные из сертификата
                                </Button>
                                </Typography>
                                <Typography paragraph style={{paddingLeft:'30%', color:'red'}}>{this.state.eds_message}</Typography>
                                        {reg && (<div style={{marginLeft:'20%', marginRight:'20%'}}>
                                        <TextField
                                    disabled
                                    className={classes.textField}
                                    classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor,}}
                                    required
                                    onChange={e => this.updateInput(e.target)}
                                    label={attributes.company_name}
                                    fullWidth
                                    theme={this.props.theme}
                                    key="company_name"
                                    id="company_name"
                                    name="company_name"
                                    margin="normal"
                                    value={this.state.reg_form_data.company_name}
                                    InputProps={{
                                        className: classes.input
                                      }}
                                    InputLabelProps={{
                                        shrink: true,
                                        className: classes.label
                                      }}
                                />
                                <TextField
                                    disabled
                                    className={classes.textField}
                                    classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor}}
                                    required
                                    onChange={e => this.updateInput(e.target)}
                                    label={attributes.contact_name}
                                    fullWidth
                                    id="contact_name"
                                    name="contact_name"
                                    margin="normal"
                                    value={this.state.reg_form_data.contact_name}
                                    InputProps={{
                                        className: classes.input
                                      }}
                                    InputLabelProps={{
                                        shrink: true,
                                        className: classes.label
                                      }}
                                />
                                <TextField
                                    className={classes.textField}
                                    classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor}}
                                    required
                                    onChange={e => this.updateInput(e.target)}
                                    label={attributes.contact_email}
                                    fullWidth
                                    id="contact_email"
                                    name="contact_email"
                                    margin="normal"
                                    value={this.state.reg_form_data.contact_email}
                                    InputProps={{className: classes.input}}
                                    InputLabelProps={{shrink: true, className: classes.label}}
                                />
                                <TextField
                                    disabled
                                    className={classes.textField}
                                    classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor}}
                                    required
                                    onChange={e => this.updateInput(e.target)}
                                    label={attributes.company_country}
                                    fullWidth
                                    id="company_country"
                                    name="company_country"
                                    margin="normal"
                                    value={this.state.reg_form_data.company_country}
                                    InputProps={{className: classes.input}}
                                    InputLabelProps={{shrink: true,className: classes.label}}
                                />
                                <TextField
                                    className={classes.textField}
                                    classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor}}
                                    required
                                    onChange={e => this.updateInput(e.target)}
                                    label={attributes.company_state}
                                    fullWidth
                                    id="company_state"
                                    name="company_state"
                                    margin="normal"
                                    value={this.state.reg_form_data.company_state}
                                    InputProps={{
                                        className: classes.input
                                      }}
                                    InputLabelProps={{
                                        shrink: true,
                                        className: classes.label
                                      }}
                                />
                                <TextField
                                    className={classes.textField}
                                    classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor}}
                                    required
                                    onChange={e => this.updateInput(e.target)}
                                    label={attributes.company_region}
                                    fullWidth
                                    id="company_region"
                                    name="company_region"
                                    margin="normal"
                                    value={this.state.reg_form_data.company_region}
                                    InputProps={{
                                        className: classes.input
                                      }}
                                    InputLabelProps={{
                                        shrink: true,
                                        className: classes.label
                                      }}
                                />
                                <TextField
                                    disabled
                                    className={classes.textField}
                                    classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor}}
                                    required
                                    onChange={e => this.updateInput(e.target)}
                                    label={attributes.company_city}
                                    fullWidth
                                    id="company_city"
                                    name="company_city"
                                    margin="normal"
                                    value={this.state.reg_form_data.company_city}
                                    InputProps={{
                                        className: classes.input
                                      }}
                                    InputLabelProps={{
                                        shrink: true,
                                        className: classes.label
                                      }}
                                />
                                <TextField
                                    disabled
                                    className={classes.textField}
                                    classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor}}
                                    required
                                    onChange={e => this.updateInput(e.target)}
                                    label={attributes.company_street}
                                    fullWidth
                                    id="company_street"
                                    name="company_street"
                                    margin="normal"
                                    value={this.state.reg_form_data.company_street}
                                    InputProps={{
                                        className: classes.input
                                      }}
                                    InputLabelProps={{
                                        shrink: true,
                                        className: classes.label
                                      }}
                                />
                                <TextField
                                    className={classes.textField}
                                    classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor}}
                                    required
                                    onChange={e => this.updateInput(e.target)}
                                    label={attributes.company_phone}
                                    fullWidth
                                    id="company_phone"
                                    name="company_phone"
                                    margin="normal"
                                    value={this.state.reg_form_data.company_phone}
                                    InputProps={{
                                        className: classes.input
                                      }}
                                    InputLabelProps={{
                                        shrink: true,
                                        className: classes.label
                                      }}
                                />
                                <TextField
                                    className={classes.textField}
                                    classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor}}
                                    required
                                    onChange={e => this.updateInput(e.target)}
                                    label={attributes.tax_company_name}
                                    fullWidth
                                    id="tax_company_name"
                                    name="tax_company_name"
                                    margin="normal"
                                    value={this.state.reg_form_data.tax_company_name}
                                    InputProps={{
                                        className: classes.input
                                      }}
                                    InputLabelProps={{
                                        shrink: true,
                                        className: classes.label
                                      }}
                                />
                                <TextField
                                    className={classes.textField}
                                    classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor}}
                                    required
                                    onChange={e => this.updateInput(e.target)}
                                    label={attributes.okpo}
                                    fullWidth
                                    id="okpo"
                                    name="okpo"
                                    margin="normal"
                                    value={this.state.reg_form_data.okpo}
                                    InputProps={{ className: classes.input}}
                                    InputLabelProps={{
                                        shrink: true,
                                        className: classes.label
                                      }}
                                />
                                <TextField
                                    className={classes.textField}
                                    classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor}}
                                    required
                                    onChange={e => this.updateInput(e.target)}
                                    label={attributes.unp}
                                    fullWidth
                                    id="unp"
                                    name="unp"
                                    disabled
                                    margin="normal"
                                    value={this.state.reg_form_data.unp}
                                    InputProps={{
                                        className: classes.input
                                      }}
                                    InputLabelProps={{
                                        shrink: true,
                                        className: classes.label
                                      }}
                                />
                                <TextField
                                    className={classes.textField}
                                    classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor}}
                                    required
                                    onChange={e => this.updateInput(e.target)}
                                    label={attributes.certificate_number}
                                    fullWidth
                                    id="certificate_number"
                                    name="certificate_number"
                                    margin="normal"
                                    value={this.state.reg_form_data.certificate_number}
                                    InputProps={{className: classes.input}}
                                    InputLabelProps={{shrink: true,className: classes.label}}
                                />

                                            <DatePicker
                                                className={classes.textField} classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor}}
                                                onChange={this.updateDateInput("certificate_date")}
                                                label={attributes.certificate_date}
                                                fullWidth
                                                format='DD.MM.YYYY'
                                                id="certificate_date"
                                                name="certificate_date"
                                                value={this.state.reg_form_data.certificate_date}
                                                InputLabelProps={{ shrink: true, className: classes.label}}
                                            />

                                                {/*<TextField
                                    className={classes.textField}
                                    classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor}}
                                    required
                                    onChange={e => this.updateInput(e.target)}
                                    label={attributes.certificate_date}
                                    fullWidth
                                    type="date"
                                    id="certificate_date"
                                    name="certificate_date"
                                    margin="normal"
                                    value={this.state.reg_form_data.certificate_date}
                                    InputProps={{
                                        className: classes.input
                                      }}
                                    InputLabelProps={{
                                        shrink: true,
                                        className: classes.label
                                      }}

                                    />*/}
                                <div className={classes.wrapperButton}>
                                <Button variant="contained" color="#76b5b8" size="large"
                                        className={classes.button}
                                        type="submit"
                                        >
                                    Регистрация
                                </Button>
                                </div>
                             </div> )}
                            <Typography paragraph style={{color:"red"}}>{this.props.message}</Typography>
                                    </form>
                            )}
                            {this.props.status == 'completed' && (
                                <Typography paragraph>{this.props.message}</Typography>
                            )}
                            </TabContainer>}
                                        <Dialog
                                            open={this.state.open}
                                            onClose={this.handleClose}
                                            aria-labelledby="form-dialog-title"
                                        >
                                            <DialogContent>
                                                {message}
                                            </DialogContent>
                                            <DialogActions>
                                                <Button onClick={this.handleClose} color="primary">
                                                    Закрыть
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
                           </Typography>
                        </Typography>)}
                        <Footer style={{width:"100%"}}/>
                    </Typography>
                );
             }
    
        

        handleRegistration = (e) => {
            e.preventDefault();
            console.log(this.state.reg_form_data);
            this.props.addRegistration(this.state.reg_form_data)
        }

        handleEdsLogin = () => {
            let data = this.parseApplet();
            console.log(data);
            if (data.code == 0) {
                let str = data.subject;
                let surname = str.split('SN=').pop().split(',')[0];
                let names = str.split('Имя, Отчество=').pop().split(',')[0];
                let full_name = `${surname} ${names}`.trim();
                let email = str.indexOf('E=') > -1 ? str.split('E=').pop().split(',')[0] : '';
                this.props.loginWithEds(data.message, data.ynp, full_name, email);
            }
            ;
            if (data.code >= 0) {
                this.setState({eds_message: data.message});
            }

        }

        handleLogin = (e) => {
            e.preventDefault();
            console.log(this.state.login_form_data);
            this.props.login(this.state.login_form_data);
            console.log(this.state);
        }

        updateInput = input => {
            let data = {[input.name]: input.value};
            let currentData = this.state.reg_form_data;
            this.setState({reg_form_data: {...currentData, ...data}});
        };
        updateLoginInput = input => {
            let data = {[input.name]: input.value};
            let currentData = this.state.login_form_data;
            this.setState({login_form_data: {...currentData, ...data}});
        };

        componentWillReceiveProps(nextProps){
            console.log('PROPS');
            if (!!Object.keys(nextProps.user).length) {
                if (nextProps.user.token) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('user', JSON.stringify(nextProps.user));
                    this.setState({user: nextProps.user, redirect: true})
                }
            }

            this.setState({message: nextProps.message, status: nextProps.status});
        }
    
}

LoginPage.propTypes = {
    classes: PropTypes.object.isRequired,
    status:  PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    user:    PropTypes.object
};

export const LoginPageWithStyles = withStyles(styles)(LoginPage);

function select(state, props) {
    const { register, message, user } = state;
    console.log('SELECT');
    console.log(register);
    console.log(user);
    return {
        user: user.data || {},
        status: register.status || 'new',
        message: register.message || '',
        fetching: register.fetching || false,
        response_status: register.response_status || ''
    };
}

function mapDispatch(dispatch) {
    return {
        addRegistration: bindActionCreators(addRegistration, dispatch),
        login: bindActionCreators(login, dispatch),
        loginWithEds: bindActionCreators(loginWithEds, dispatch)
    };
}

export default connect(select, mapDispatch)(LoginPageWithStyles);



// WEBPACK FOOTER //
// ./assets/src/js/components/pages/LoginPage.jsx